import { COLORS, WALLET_COLORS as C } from '@/constants';

export function MenuIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M2.8125 5.625C2.8125 5.10723 3.23223 4.6875 3.75 4.6875H26.25C26.7678 4.6875 27.1875 5.10723 27.1875 5.625C27.1875 6.14277 26.7678 6.5625 26.25 6.5625H3.75C3.23223 6.5625 2.8125 6.14277 2.8125 5.625Z" fill={COLORS.iconGlobal}/>
      <path fillRule="evenodd" clipRule="evenodd" d="M2.8125 15C2.8125 14.4822 3.23223 14.0625 3.75 14.0625H26.25C26.7678 14.0625 27.1875 14.4822 27.1875 15C27.1875 15.5178 26.7678 15.9375 26.25 15.9375H3.75C3.23223 15.9375 2.8125 15.5178 2.8125 15Z" fill={COLORS.iconGlobal}/>
      <path fillRule="evenodd" clipRule="evenodd" d="M2.8125 24.375C2.8125 23.8572 3.23223 23.4375 3.75 23.4375H26.25C26.7678 23.4375 27.1875 23.8572 27.1875 24.375C27.1875 24.8928 26.7678 25.3125 26.25 25.3125H3.75C3.23223 25.3125 2.8125 24.8928 2.8125 24.375Z" fill={COLORS.iconGlobal}/>
    </svg>
  );
}

export function InboxIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M18.4681 23.0048C18.0832 22.7684 17.6259 22.6788 17.1803 22.7527C16.4452 22.8744 15.7887 22.9344 15 22.9344C8.53457 22.9344 3.75 18.4306 3.75 13.3422C3.75 8.25383 8.53457 3.75 15 3.75C21.4654 3.75 26.25 8.25383 26.25 13.3422C26.25 16.2317 24.6915 18.9501 22.1243 20.8021C21.6357 21.1546 21.3463 21.7203 21.3463 22.3227V24.7728L18.4681 23.0048ZM23.2213 28.125V22.3227C26.1896 20.1813 28.125 16.9344 28.125 13.3422C28.125 6.98668 22.2531 1.875 15 1.875C7.74692 1.875 1.875 6.98668 1.875 13.3422C1.875 19.6977 7.74692 24.8094 15 24.8094C15.8986 24.8094 16.6578 24.7398 17.4867 24.6025L23.2213 28.125Z" fill={COLORS.iconGlobal}/>
    </svg>
  );
}

export function ChevronIcon({ up }: { up?: boolean }) {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth={2} className={up ? 'rotate-180' : ''}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 9l6 6 6-6" />
    </svg>
  );
}



export function GlassPanel({ children, className = '' }: { children: React.ReactNode; className?: string }) {
  return (
    <div className={`relative overflow-hidden rounded-2xl border ${className}`} style={{ borderColor: C.border, background: C.bgGlass, backdropFilter: 'blur(2px)', boxShadow: C.shadowGlass }}>
      {children}
    </div>
  );
}

export function OtherPanel({ children, className = '', overflowVisible = false }: { children: React.ReactNode; className?: string; overflowVisible?: boolean }) {
  return (
    <div className={`relative ${overflowVisible ? 'overflow-visible' : 'overflow-hidden'} rounded-2xl border ${className}`} style={{ borderColor: C.border, background: C.bgGlass, backdropFilter: 'blur(2px)', boxShadow: C.otherShadow }}>
      {children}
    </div>
  );
}

export function SectionHeader({ title, action, onAction }: { title: string; action?: string; onAction?: () => void }) {
  return (
    <div className="flex items-center justify-between px-4 py-3 text-[#E5E7EB]">
      <span className="text-sm font-semibold">{title}</span>
      {action && onAction && <button type="button" onClick={onAction} className="text-xs" style={{ color: C.arrowKey }}>{action}</button>}
    </div>
  );
}

export function ActionIcon({ type }: { type: 'recharge' | 'withdraw' | 'transfer' }) {
  if (type === 'transfer') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
        <path d="M20.9106 15.2912L15.8004 20.4116" stroke="white" strokeWidth="1.53" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M3.57019 15.2912H20.9102" stroke="white" strokeWidth="1.53" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M3.5705 9.19077L8.6807 4.07037" stroke="url(#walletTransferGradient0)" strokeWidth="1.53" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M20.9105 9.19055H3.5705" stroke="url(#walletTransferGradient1)" strokeWidth="1.53" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <defs>
          <linearGradient id="walletTransferGradient0" x1="6.1256" y1="4.07037" x2="6.1256" y2="9.19077" gradientUnits="userSpaceOnUse"><stop stopColor="#F5EC63"/><stop offset="1" stopColor="#A7E768"/></linearGradient>
          <linearGradient id="walletTransferGradient1" x1="12.2405" y1="9.19055" x2="12.2405" y2="10.1906" gradientUnits="userSpaceOnUse"><stop stopColor="#F5EC63"/><stop offset="1" stopColor="#A7E768"/></linearGradient>
        </defs>
      </svg>
    );
  }

  const out = type === 'withdraw';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
      <path d="M9.69006 14.0254C9.69006 15.0148 10.4551 15.8104 11.3935 15.8104H13.3111C14.1271 15.8104 14.7901 15.1168 14.7901 14.2498C14.7901 13.3216 14.3821 12.985 13.7803 12.7708L10.7101 11.6998C10.1083 11.4856 9.70027 11.1592 9.70027 10.2208C9.70027 9.36405 10.3633 8.66025 11.1793 8.66025H13.0969C14.0353 8.66025 14.8003 9.45585 14.8003 10.4452" stroke="white" strokeWidth="1.53" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.2403 7.65057V16.8306" stroke="white" strokeWidth="1.53" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M22.4405 12.2405C22.4405 17.8709 17.8709 22.4405 12.2405 22.4405C6.6101 22.4405 2.0405 17.8709 2.0405 12.2405C2.0405 6.6101 6.6101 2.0405 12.2405 2.0405" stroke="url(#walletMoneyGradient0)" strokeWidth="1.53" strokeLinecap="round" strokeLinejoin="round"/>
      <path d={out ? 'M22.4407 6.1205V2.0405H18.3607' : 'M17.3405 3.06073V7.14073H21.4205'} stroke="url(#walletMoneyGradient1)" strokeWidth="1.53" strokeLinecap="round" strokeLinejoin="round"/>
      <path d={out ? 'M17.3405 7.1405L22.4405 2.0405' : 'M22.4405 2.0405L17.3405 7.1405'} stroke="url(#walletMoneyGradient2)" strokeWidth="1.53" strokeLinecap="round" strokeLinejoin="round"/>
      <defs>
        <linearGradient id="walletMoneyGradient0" x1="12.2405" y1="2.0405" x2="12.2405" y2="22.4405" gradientUnits="userSpaceOnUse"><stop stopColor="#A7E768"/><stop offset="1" stopColor="#FBDD65"/></linearGradient>
        <linearGradient id="walletMoneyGradient1" x1="19.3805" y1="3.06073" x2="19.3805" y2="7.14073" gradientUnits="userSpaceOnUse"><stop stopColor="#A7E768"/><stop offset="1" stopColor="#FBDD65"/></linearGradient>
        <linearGradient id="walletMoneyGradient2" x1="19.8905" y1="2.0405" x2="19.8905" y2="7.1405" gradientUnits="userSpaceOnUse"><stop stopColor="#A7E768"/><stop offset="1" stopColor="#FBDD65"/></linearGradient>
      </defs>
    </svg>
  );
}

